import Vue from 'vue'
import axios from 'src/config/axios'
import ElementUI from 'element-ui'
import axios2 from 'src/config/axios2'
import 'element-ui/lib/theme-chalk/index.css'
import Resource from 'vue-resource'
import vueEventCalendar from 'vue-event-calendar'
import VueFeatherIcon from 'vue-feather-icon'
import router from 'src/config/routes'
import store from 'src/store'
import VueTyperPlugin from 'vue-typer'
import Tooltip from 'vue-directive-tooltip'
import VueDND from 'awe-dnd'
// import Upload from 'vue-drop-upload'
import elementSecDev from './config/elementSecDev'
// 引入katex
import xesKatex from 'xes-katex'
// 引入教研组件库
import {
  upload
} from 'xes-frontend-ui'
Vue.use(xesKatex)
Vue.use(upload)
// 排序插件
Vue.use(VueDND)
// 上传插件
// Vue.use(Upload)

// Resource logic
Vue.use(Resource)
Vue.http.options.emulateJSON = true

// Vue.use(ElementUI)
Vue.use(ElementUI, {
  size: 'mini'
})
Vue.use(VueFeatherIcon)
Vue.use(vueEventCalendar, {
  locale: 'en'
})
Vue.use(VueTyperPlugin)
Vue.use(Tooltip)
// Vue.use(Element, { size: 'small' })

// Import top level component
import App from './App.vue'
import 'bootstrap/dist/css/bootstrap.css'
//  for element 1.9.9 below
// import 'element-ui/lib/theme-default/index.css'
// import 'element-ui/lib/theme-chalk/index.css'
//import 'material-design-icons/iconfont/material-icons.css'
import 'dripicons/webfont/webfont.css'
// import 'vue-directive-tooltip/css/index.css'
// icon-font
import 'src/assets/font/iconfont.css'
// 引入element ui 相关的样式更改
import 'src/sass/_element.scss'

// 创建eventBus
const eventBus = new Vue()
window.eventBus = eventBus
// 将ElementUI常用扩展封装至vue原型
elementSecDev()

// Check local storage to handle refreshes
if (window.localStorage) {
  if (store.state.token !== window.localStorage.getItem('token')) {
    store.commit('SET_TOKEN', window.localStorage.getItem('token'))
  }
}
// 初始化全局变量
window.coursewareSocket = null

// Some middleware to help us ensure the user is authenticated.

// Start out app!
// eslint-disable-next-line no-new
new Vue({
  el: '#app',
  router,
  store: store,
  render: h => h(App)
})

require('bootstrap')
require('admin-lte')
require('../node_modules/admin-lte/dist/js/demo.js')
require('../node_modules/admin-lte/plugins/slimScroll/jquery.slimscroll.js')

// import fundebug from 'fundebug-javascript'
// fundebug.apikey = '1fe09d405a38cf32f98a9b2ac4a0a4a0a5493e8f5b299ca23239cc5956e1e5b5'

function formatComponentName(vm) {
  if (vm.$root === vm) return 'root'

  var name = vm._isVue ? (vm.$options && vm.$options.name) || (vm.$options && vm.$options._componentTag) : vm.name
  return (name ? 'component <' + name + '>' : 'anonymous component') + (vm._isVue && vm.$options && vm.$options.__file ? ' at ' + (vm.$options && vm.$options.__file) : '')
}

// Vue.config.errorHandler = (err, vm, info) => {
//   let componentName = formatComponentName(vm)
//   let propsData = vm.$options && vm.$options.propsData

//   fundebug.notifyError(err, {
//     metaData: {
//       componentName: componentName,
//       propsData: propsData,
//       info: info
//     }
//   })
// }



// WEBPACK FOOTER //
// ./src/main.js